import $ from 'jquery';

// New modules that are safe to add to site even when old JavaScript is around. Use this for all new features / non-conflicting scripts
// Everything new goes here!
import coreModules from './modules/bundles/core-modules';

// NHT specific
import scrollToElement from './modules/nht/scrollToElement';
import contactUs from './modules/nht/contact-us';
import { initializeABTests } from './modules/nht/ab-tests';

//Initialize everything on document ready
$(document).ready(() => {
  console.log('NHT BUNDLE');

  // Common modules
  coreModules.init();

  scrollToElement.init();
  contactUs.init();
  initializeABTests();

  const ajaxForms = document.querySelectorAll('[data-ajax-form]');
  if (ajaxForms.length) {
    import(/* webpackChunkName: "nht-ajax-forms", webpackMode: "lazy" */'./modules/nht/ajax-forms').then(m => { // jshint ignore:line
      m.default.init(ajaxForms);
    });
  }

  const newsletter = document.querySelector('.nht-newsletter');
  if (newsletter) {
    import(/* webpackChunkName: "nht-newsletter", webpackMode: "lazy" */'./modules/nht/newsletter').then(m => { // jshint ignore:line
      m.default.init();
    });
  }

  const heavyStories = document.querySelector('[data-heavy-stories]');
  if (heavyStories) {
    import(/* webpackChunkName: "nht-heavy-stories", webpackMode: "lazy" */'./modules/nht/heavy-stories').then(m => { // jshint ignore:line
      m.default.init();
    });
  }

  const wheelSelector = document.getElementById('wheel-selector');
  if (wheelSelector) {
    import(/* webpackChunkName: "nht-wheel-selector", webpackMode: "lazy" */'./modules/nht/wheel-selector').then(m => { // jshint ignore:line
      m.init(wheelSelector);
    });
  }

  const wheelOrder = document.getElementById('nht-wheel-order');
  if (wheelOrder) {
    import(/* webpackChunkName: "nht-wheel-order", webpackMode: "lazy" */'./modules/nht/wheel-order').then(m => { // jshint ignore:line
      new m.default(wheelOrder);
    });
  }

  const nhtTyreSelectorV2 = window.nhtTireSelectorV2;
  if (nhtTyreSelectorV2) {
    import(/* webpackChunkName: "nht-tyre-selector-v2", webpackMode: "lazy" */'./modules/nht/tyre-selector-v2').then(m => { // jshint ignore:line
      m.init(nhtTyreSelectorV2);
    });
  }

  const isNHTMediaPage = document.querySelector('.nht-media');
  if (isNHTMediaPage) {
    import(/* webpackChunkName: "nht-media-page", webpackMode: "lazy" */'./modules/nht/mediaPage').then(m => { // jshint ignore:line
      m.default.init();
    });
  }

  const wheelsListing = document.getElementById('wheels-listing');
  if (wheelsListing) {
    import(/* webpackChunkName: "nht-wheels-listing", webpackMode: "lazy" */'./modules/nht/wheels-listing').then(m => { // jshint ignore:line
      m.init(wheelsListing);
    });
  }

  const wheelOrderForms = document.querySelectorAll('[data-wheel-order-standalone]');
  if (wheelOrderForms.length) {
    import(/* webpackChunkName: "nht-wheel-order-form", webpackMode: "lazy" */'./modules/nht/wheel-order-form').then(m => { // jshint ignore:line
      m.init(wheelOrderForms);
    });
  }

  const productSelectorEmbeds = document.querySelectorAll('.nht-product-selector-embed');
  if(productSelectorEmbeds.length) {
    import(/* webpackChunkName: "nht-product-selector-embed", webpackMode: "lazy" */'./modules/nht/product-selector-embed').then(m => { // jshint ignore:line
      m.init(productSelectorEmbeds);
    });
  }
});
